module.exports = __webpack_public_path__ + "static/carepath-logo-191972ab98ac2d98660adfd2c1a1988c.png";